import { freeze } from 'icepick';
import {
	type Action,
	VELOCITY_DATA_FETCH,
	VELOCITY_DATA_FETCH_IN_PROGRESS,
	VELOCITY_DATA_FETCH_FAILURE,
	VELOCITY_DATA_FETCH_SUCCESS,
} from '../../../actions/velocity-data-fetch';
import { SprintsFetchStatus, type SprintsState } from './types';

const defaultState: SprintsState = {
	data: [],
	fetchStatus: SprintsFetchStatus.PENDING,
	fetchProgress: 0,
};

export const sprintsReducer = (
	state: SprintsState = defaultState,
	action: Action,
): SprintsState => {
	switch (action.type) {
		case VELOCITY_DATA_FETCH: {
			return {
				fetchStatus: SprintsFetchStatus.IN_PROGRESS,
				fetchProgress: 0,
				data: [],
			};
		}
		case VELOCITY_DATA_FETCH_IN_PROGRESS:
			return {
				fetchStatus: SprintsFetchStatus.IN_PROGRESS,
				fetchProgress: action.payload.progress,
				fetchProgressUpdate: action.payload.progressUpdate,
				data: [],
			};
		case VELOCITY_DATA_FETCH_SUCCESS:
			return {
				fetchStatus: SprintsFetchStatus.SUCCESS,
				fetchProgress: 1,
				data: freeze(action.payload.sprints),
			};
		case VELOCITY_DATA_FETCH_FAILURE:
			return {
				fetchStatus: SprintsFetchStatus.FAILURE,
				fetchProgress: 1,
				fetchError: action.payload.error,
				data: [],
			};
		default:
			return state;
	}
};
